import Carousel from 'react-material-ui-carousel'
import {Box, Stack, Typography, useTheme} from "@mui/material";
import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import CONFIG from "../config/_config";

const Item = forwardRef((props, ref) => {
    const {palette} = useTheme();
    const [classList, setClassList] = useState('hidden')

    useImperativeHandle(ref, () => ({

        showDescription() {
            setTimeout(() => {
                setClassList('animated fadeInUp');
            }, 1500)
        },

        hideDescription() {
            setTimeout(() => {
                setClassList('hidden');
            }, 2000);
        }

    }));

    return (
        <Stack height='calc(100dvh - 70px)'
               position='relative'
               style={{
                    backgroundImage: `url(${CONFIG.appHost}${props.item.image})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover'
                }}
               alignItems='center'
        >
            <Box
                className={classList}
                m='auto'
                width={{md: '100vw', xs: 'auto'}}
                height={{md: '200px', xs: 'auto'}}
                py={4}
                bgcolor='rgba(151,25,22,.9)'
                px={{md: 'calc(50% - 350px)', xs: 1}}
                position='absolute'
                bottom={{xs: '10%', md: 0}}
                boxShadow='0 5px 5px rgba(0,0,0,.4)'
                boxSizing='border-box'
            >
                <Typography color={palette.brAccent.main} sx={{textTransform: 'uppercase'}} variant='h2' textAlign='left' px={1}>
                    {props.item.title}
                </Typography>
                <Typography variant='body1' fontSize='1.3rem' lineHeight='1.4rem' mt={1} px={1} textAlign='left' color='white'>
                    {props.item.description}
                </Typography>
            </Box>
        </Stack>
    )
});

const NewsCarousel = (props) => {
    const {items} = props;
    const itemsRef = useRef([])

    useEffect(() => {
        itemsRef.current[0].showDescription()
    }, []);

    useEffect(() => {
        itemsRef.current = itemsRef.current.slice(0, items.length);
    }, [items]);
    const onItemChange = (currentItemIndex, prevItemIndex) => {
        itemsRef.current[currentItemIndex].showDescription();
        if (currentItemIndex !== prevItemIndex)
            itemsRef.current[prevItemIndex].hideDescription();
    }

    return <>
        <Carousel
            indicatorContainerProps={{
                style: {
                    position: 'absolute',
                    bottom: '15px'
                }

            }}
            interval={4000}
            animation='slide'
            swipe={false}
            duration={1000}
            navButtonsAlwaysVisible={true}
            onChange={onItemChange}
            navButtonsProps={{
                style: {
                    background: 'transparent',
                }
            }}
        >
            {
                items.map( (item, i) => <Item key={i} id={item.id} ref={el => itemsRef.current[i] = el} item={item} /> )
            }
        </Carousel>
    </>
}

export default NewsCarousel;